import { useRef } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import EmojiPicker from "emoji-picker-react";
import { OverlayPanel } from "primereact/overlaypanel";

export const EmojiTextArea = ({ editorText, setEditorText, userCount }) => {
  const textareaRef = useRef(null);
  const overlayRef = useRef(null);

  // Insert emoji at cursor position
  const handleEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji;
    const input = textareaRef.current;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    const newText =
      editorText.substring(0, start) + emoji + editorText.substring(end, editorText.length);

    setEditorText(newText);

    // set cursor after emoji
    setTimeout(() => {
      input.selectionStart = input.selectionEnd = start + emoji.length;
      input.focus();
    });
  };

  return (
    <div>
      <div className="emoji-block">
        <InputTextarea
          ref={textareaRef}
          value={editorText}
          onChange={(e) => setEditorText(e.target.value)}
          className="add-notes"
          placeholder="Message"
          rows={10}
          maxLength={170}
          autoResize
          disabled={userCount === 0}
        />

        {/* Emoji button */}
        <button
          type="button"
          className="emoji-button"
          onClick={(e) => overlayRef.current.toggle(e)}
        >
          😀
        </button>
      </div>

      {/* Picker inside PrimeReact OverlayPanel */}
      <OverlayPanel ref={overlayRef}>
        <EmojiPicker onEmojiClick={handleEmojiClick} lazyLoadEmojis skinTonesDisabled={true} />
      </OverlayPanel>
    </div>
  );
}
